import Module from '../utils/Module';
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import ResizeManager from '../utils/ResizeManager';
import EventsManager from "../utils/EventsManager";
import CustomEvents from "../utils/CustomEvents";

gsap.registerPlugin(ScrollTrigger);

export default class TimelineModule extends Module {
  constructor(options) {
    super(options);

    this.DOMEl = options.element;

    this.canAnim = false;
    this.animComplete = false;
    this.resizeTimer = 0;

    this.titleContent = document.querySelector(".timeline-module__headings h3");
    this.descriptionContent = document.querySelector(".timeline-module__headings .description");
    this.wrapper = document.querySelector('.timeline-module__items_wrapper');
    this.square = document.querySelector(".timeline-module__square");
    this.squareInner = document.querySelector(".timeline-module__square-inner");

    this.squareMobile = document.querySelector(".timeline-module__square-mobile");
    this.squareInnerMobile = document.querySelector(".timeline-module__square-inner-mobile");

    this.items = document.querySelector(".timeline-module__items");

    this.timeline = gsap.timeline().pause();
    this.animComplete = false;
    this.Scroll = false;
    this.ScrollMobile = false;
    this.ST = false;

    this.colContainer = document.querySelector('.timeline-module__items_wrapper');
    this.item = document.querySelector('.timeline-module__square-inner');
    this.itemMobile = document.querySelector('.timeline-module__square-inner-mobile');
    this.intPad = 0;

    this.init();
  }

  init() {


    if (this.titleContent) {
      gsap.timeline().to(this.titleContent, {
        css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'},
        duration: 0.7,
        ease: "power2.out"
      });
    }
    if (this.descriptionContent) {
      gsap.timeline().to(this.descriptionContent, {
        css: {
          'opacity': 1,
          'transform': 'translate3d(0,0,0)'
        }, duration: 0.7, ease: "power2.out"
      }, '-=0.6');
    }

    ResizeManager.bind("timeline-resize", this.onResize.bind(this));

    document.addEventListener('scroll', this.onScroll.bind(this));

  }

  onResize() {
    this.follow();
  }

  onScroll() {
    this.follow();
  }

  /** ------------------------------
   * Private methods
   --------------------------------- */

  follow() {
    var scrollTop = document.documentElement.scrollTop?
      document.documentElement.scrollTop:document.body.scrollTop;
    let topContainer = (this.colContainer.getBoundingClientRect().top + scrollTop) - 130;
    let bottomContainer = topContainer + this.colContainer.clientHeight;
    let topWindow = window.pageYOffset;

    let percent = (topWindow - topContainer) / (this.colContainer.clientHeight - 260 - this.item.clientHeight);

    //DESKTOP
    if (window.innerWidth >= 768) {
      if (topWindow >= topContainer && topWindow <= (bottomContainer - (this.item.clientHeight + 230))) {
        this.intPad = topWindow - topContainer;
        if (percent < 0.1) {
          this.item.style.transform = 'translateY(' + this.intPad + 'px) scale(0.1)';
        }
        else if (percent > 1)
        {
          this.item.style.transform = 'translateY(' + this.intPad + 'px) scale(1)';
        }
        else {
          this.item.style.transform = 'translateY(' + this.intPad + 'px) scale(' + percent + ')';
        }
      }
      // just a little safety fall back
      else {
        if (topWindow < topContainer) {
          this.item.style.transform = ' translateY(0px) scale(0.1)';
        }
      }
    }
    //MOBILE
    else
    {
      if (percent < 0.1) {
        this.itemMobile.style.transform = 'scaleY(0.1)';
      }
      else if (percent > 1)
      {
        this.itemMobile.style.transform = 'scaleY(1)';
      }
      else {
        this.itemMobile.style.transform = 'scaleY(' + percent + ')';
      }
    }
  }

}

